import { allBonesFound, collectBone, completeQuest, getState } from '../app/state';

export const QUEST_REWARD = {
  type: 'message',
  title: 'Enquête résolue',
  message: 'Le coupable dormait sous le comptoir.',
  promoCode: null,
} as const;

export interface BoneResult {
  collected: boolean;
  total: number;
  questReady: boolean;
}

/** Ramasser un os déjà trouvé ne doit rien changer. */
export function pickUpBone(boneId: string): BoneResult {
  const collected = collectBone(boneId);
  return {
    collected,
    total: getState().collectedBones.length,
    questReady: allBonesFound(),
  };
}

/** Réclamer la récompense : possible une seule fois, et seulement au complet. */
export function claimReward(): { granted: boolean; alreadyClaimed: boolean } {
  if (getState().questCompleted) return { granted: false, alreadyClaimed: true };
  return { granted: completeQuest(), alreadyClaimed: false };
}
